module.exports = __webpack_public_path__ + "media/images/realizacje/real8-84017131e7430a1dc93b0dc9b4f17837.png";